<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="2.5" y="5" width="19" height="14" rx="3" />
    <path d="m3.5 7.5 7.4 5a2 2 0 0 0 2.2 0l7.4-5" />
  </svg>
</template>
